import {
  BRAND_PROD_HOSTS,
  BRAND_STAGING_HOSTS,
} from '@rover/constants/src/platform/hosts.constants';

import { PlatformEnvironment } from './constants';
import { getApiMapping } from './internals';

export async function getApiEnvironmentName(platform: string): Promise<PlatformEnvironment | null> {
  const apiBase = await getApiMapping();

  if (!apiBase) {
    return null;
  }

  // Native returns a full URL (e.g. https://www.rover.com); extract just the hostname.
  // Web returns window.location.hostname which is already a bare hostname.
  const hostname = apiBase.includes('://') ? new URL(apiBase).hostname : apiBase;

  if (BRAND_STAGING_HOSTS.test(hostname)) {
    /**
     * iOS and Android only have prod and debug Splunk indexes. While indexes
     * will be based on the API mapping instead of build environment, we still
     * want to use the existing native platform indexes until we have adopted
     * this module more widely in the app.
     */
    return platform === 'web_client' ? PlatformEnvironment.STAGING : PlatformEnvironment.DEBUG;
  }

  if (BRAND_PROD_HOSTS.test(hostname)) {
    return PlatformEnvironment.PROD;
  }

  return null;
}
